import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() logo: string;
  @Input() logoHeight = '2rem';
  @Input() address: string;
  @Input() phoneNumber: string;
  @Input() textNumber: string;
  @Input() logoUrl: string;
  @Input() showBanner: boolean;
  @Input() showBannerOnMobile: boolean;
  @Input() isMobile: boolean;
  @Input() customContactInfo: boolean;
}
